"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preview_types_1 = require("@wix/wix-vod-constants/dist/common/preview-types");
var getTrailerTypeString = function (videoItem) {
    if (!videoItem) {
        return 'none';
    }
    var trailerType = videoItem.trailerType;
    trailerType = trailerType || preview_types_1.PREVIEW_TYPES.FIRST_20_SEC;
    switch (trailerType) {
        case preview_types_1.PREVIEW_TYPES.FIRST_20_SEC:
            return 'preview';
        case preview_types_1.PREVIEW_TYPES.TRAILER:
            return 'trailer';
        case preview_types_1.PREVIEW_TYPES.NONE:
        default:
            return 'none';
    }
};
exports.default = getTrailerTypeString;
//# sourceMappingURL=get-trailer-type-string.js.map